<template lang="pug">
  #StoresManagerIndex
    .content-header.bg-secondary.rounded-bottom-1rem.d-flex.align-items-center
      h5.mb-0 櫃點管理
    .container-width
      b-form-group.mx-3.mt-3.mb-1.text-gray
        b-form-select.border-0(
          id="card_type",
          required,
          v-model="store",
          style="padding-right:3rem; border-radius: 20px;background-color: #eee;"
          @change='updateStoreDataHandler()'
        )
          template(
            v-slot:first
          )
            b-form-select-option(
              :value="null",
              disabled
            ) 請選擇櫃點
          b-form-select-option(
            v-for="(store,index) in personnelStore",
            :key="`${store.id}_${store.id}`",
            :value="store.id"
          ) {{ store.title }}
      .counter_tabs.mt-3
        .counter_tab.tab_style(:class="{ 'active' : nowSelectType==='index-sa'}", @click="changeTypeHandler('index-sa')")
          span 櫃點BA
        .counter_tab.tab_style(:class="{ 'active' : nowSelectType==='index-member'}" @click="changeTypeHandler('index-member')")
          span 櫃點顧客
        .counter_tab.tab_style(:class="{ 'active' : nowSelectType==='index-reservation'}" @click="changeTypeHandler('index-reservation')")
          span 櫃點預約
        //- .counter_tab.tab_style(:class="{ 'active' : nowSelectType==='index-change-member-sa'}" @click="changeTypeHandler('index-change-member-sa')")
        //-   span 分配顧客

      .p-3(v-if="store !== null")
        .d-flex.align-items-center(v-if="nowSelectType !== 'index-reservation'")
          .col.px-0
            b-form-input.border-0(
              v-model.trim="searchInput.store",
              style="border-radius: 20px;background-color: #eee;",
              placeholder="搜尋暱稱或MARSID"
            )
          .col-auto.pl-2.pr-0
            button.btn.btn-block.btn-remind.font-weight-bold.btn-custom.px-3(
              type="button",
              @click="searchHandler",
              style="border: 0.4rem solid #fff;border-radius: 50px;padding: 5px;border: 4px solid #000;box-shadow: 0.2rem 0.2rem 0 #00000033;"
              ) 搜尋
        i.fas.fa-users.my-3.pr-1(v-if='!isChangeMember')
          span.text-danger.ml-1.pr-1.font-weight-bold {{ filterMoney(storeData.length) }}
          | 位
        .border-0.customerCard.overflow-hidden.p-0(
          v-for="(store,index) in storeData",
          :key="index",
          v-if="storeData && storeData.length > 0"
        )
          //- 店鋪BA
          .typeOneShow(
            v-if="nowSelectType === 'index-sa'"
          )
            .row.align-items-center.border-bottom.pb-3.mb-3.no-gutters
              .pr-3
                ProfilePhotoSticker.d-flex.align-items-center.justify-content-center.border.border-black(
                  :profileUrl="store.picture_url",
                  :style="{ 'width': '80px', 'height': '80px' }"
                )
              .pl-1
                p.mb-0.font-weight-bold {{ store.preferred_name }}
                .text
                  label.m-0 員工編號:
                   span {{ store.code }}
                i.custom.icon-icon_circlemember
                  span.font-weight-bolder 顧客數：{{ store.member_count }}位

          //- 店鋪顧客
          .typeTwoShow(
            v-if="nowSelectType === 'index-member'"
          )
            .row.align-items-center.border-bottom.pb-3.mb-3.no-gutters
              .pr-3
                ProfilePhotoSticker.d-flex.align-items-center.justify-content-center.border.border-black(
                  :profileUrl="store.picture_url",
                  :style="{ 'width': '80px', 'height': '80px' }"
                )
              .pl-1
                p.mb-0.font-weight-bold {{ store.display_name }}
                .text
                  label.m-0 MARSID:
                    span {{ store.code }}
                .text
                  label.m-0 負責BA:
                    span {{ store.sa_chinese_last_name }}{{ store.sa_chinese_first_name }}
          //- 店鋪預約
          .typeThreeShow(
            v-if="nowSelectType === 'index-reservation'"
          )
            .row.align-items-center.border-bottom.pb-3.mb-3.no-gutters
              .pr-3
                ProfilePhotoSticker.d-flex.align-items-center.justify-content-center.border.border-black(
                  :profileUrl="store.picture_url",
                  :style="{ 'width': '80px', 'height': '80px' }"
                )
              .pl-1
                p.mb-0.font-weight-bold {{ store.customer_chinese_last_name }}
                .text
                  label.m-0 MARSID:
                    span {{ store.mars_id }}
                .text
                  label.m-0 預約活動:
                    span {{ store.CampaignName }}
                .text
                  label.m-0 預約時間:
                    span {{ store.RegisterDate }}
                .text
                  label.m-0 負責BA:
                    span {{ store.personnel_name }}
          .labelTag(
            v-if="store.status === 'expired'",
            style="right: 0;bottom: 0;"
          )
            span.labelTag__text 已過期
              //- 店鋪顧客
          .typeFourShow.pb-3(
            v-if="nowSelectType === 'index-change-member-sa' && !isChangeMember"
          )
            .row.align-items-center.border-bottom.pb-3.no-gutters
              .content-invitation.mr-2
                input.invitation_checker(
                  type="checkbox",
                  :id="`checkbox-group-${index}`",
                  name="selectTemps",
                  :checked="isChecked(index)"
                  :class="{ 'hidden-check': isChecked(index) }"
                )
                .input_wrap.d-flex
                  .invitation-icon.border-black.mr-2(@click="selectTempHandler(store.id)")
              .custom-member.d-flex
                .mr-1
                  ProfilePhotoSticker.d-flex.align-items-center.justify-content-center.border.border-black(
                    :profileUrl="store.picture_url",
                    :style="{ 'width': '65px', 'height': '65px' }"
                  )
                .member_info.pl-1
                  .member_name.mb-0.font-weight-bold
                    span {{ store.customer_chinese_last_name }}
                  .member_text.d-flex
                    label.m-0.d-flex
                      .m-0 MARSID:
                         span(style='-webkit-box-flex: -ms-flex: 1; flex: 1;') {{ store.code }}
                  .member_text.d-flex
                    label.m-0.d-flex 負責BA:
                      span {{ store.preferred_name }}
                      .member_info
        infinite-loading(
          @infinite="infiniteHandler",
          :identifier="infiniteId",
          spinner="bubbles"
          v-if='!isChangeMember'
        )
          .cursor-default(slot="no-more") 無更多資料
          .cursor-default(slot="no-results") 無更多資料
          .cursor-default(slot="error") 發生錯誤，請重整重試一次
        .typeFourShow.py-3(v-if='isChangeMember')
          .member_assignment_modal.p-3.border-black
            .modal_header
              h4 分配顧問
              .modal_close_btn
                i.custom.icon-icon_close(@click='closeCheckChangeMember()')
            .modal_body.d-flex
              .memberList.d-block.position-relative.my-1.mr-4(v-for="(member,index) in selectTemps")
                ProfilePhotoSticker.d-flex.align-items-center.justify-content-center.border.border-black(
                  :profileUrl="member.picture_url",
                  :style="{ 'width': '45px', 'height': '45px' }"
                )
                  .assignment_client_name
                span {{ member.customer_chinese_last_name }}
                span.assignment_client_delete(@click="selectTempHandler(member.id)")
                  i.custom.icon-icon_close
            .mt-3
              h5.text-center 分配給
              multiselect.mt-3(
                v-model="changePersonnel",
                tag-placeholder="輸入搜尋顧問",
                placeholder="請選擇顧問",
                selectedLabel="已選擇",
                selectLabel="點擊新增顧問",
                label="preferred_name",
                track-by="id"
                :options="personnel",
                :allow-empty="false"
                :close-on-select="true",
                :deselectLabel="''",
                noOptions="無顧問",
              )
                template(slot="noOptions")
                  strong 無顧問
                template(slot="noResult")
                  strong 無顧問
              .d-flex.align-items-center.justify-content-center.mt-3
                b-button.font-weight-bold.mt-0.btn-custom(
                  variant="primary",
                  block,
                  @click="sendChangeMemberhHandler()",
                  style="width: 50%; height: 60%; border: 0.4rem solid #fff;border-radius: 50px;padding: 0px 15px;border: 4px solid #FFF;box-shadow: 0.2rem 0.2rem 0 #00000033;"
                ) 送出
      .d-flex.w-100.pb-2.counter_fixed_btn.position-fixed.align-items-center.justify-content-center(
        style="bottom: 0;bottom: 50px;height: 60px;z-index: 3;",
        v-if="nowSelectType ==='index-change-member-sa' && !isChangeMember"
      )
        b-button.font-weight-bold.mt-0.btn-custom(
          variant="primary",
          block,
          @click="checkChangeMemberhHandler()",
          style="width: 50%; height: 60%; border: 0.4rem solid #fff;border-radius: 50px;padding: 0px 15px;border: 4px solid #FFF;box-shadow: 0.2rem 0.2rem 0 #00000033;"
        ) 分配顧客

</template>

<script>
import { mapState } from 'vuex';
import ProfilePhotoSticker from '@/components/profilePhotoSticker/ProfilePhotoStickerComponent.vue';
import InfiniteLoading from 'vue-infinite-loading';
import { SIC_STORES_MANAGER_EDIT_SA } from '@/router/sic/stores-manager';
const _ = require('lodash');

export default {
  name: 'StoresManagerIndex',
  components: {
    ProfilePhotoSticker,
    InfiniteLoading
  },
  data() {
    return {
      nowSelectType: 'index-sa',
      nowSelectStatus: 'checking',
      infiniteId: +new Date(),
      storesSelect: {
        dealer: null,
        store: null
      },
      selectTemps: [],
      isChangeMember: false,
      changePersonnel: null,
      store: null,
      lastStore: null,
      searchInput: {
        store: ""
      }
    };
  },
  created() {
    const vm = this;
    vm.$swal.fire({
      title: '載入中，請稍候',
      allowOutsideClick: false,
      willOpen: () => {
        this.$swal.showLoading();
      }
    });
    vm.$store.commit('sic_stores_manager/resetHandler');
    vm.$store.commit('toggleLoading', false);
    vm.$swal.close();
    vm.infiniteId += 1;
  },
  methods: {
    infiniteHandler($state) {
      const vm = this;
      let targetApi;
      switch (vm.nowSelectType) {
        case 'index-sa':
          targetApi = 'getIndexSaHandler';
          break;
        case 'index-member':
          targetApi = 'getIndexCustomerHandler';
          break;
        case 'index-reservation':
          targetApi = 'getIndexReservationHandler';
          break;
        case 'index-change-member-sa':
          targetApi = 'getIndexCustomerHandler';
          break;
        default:
          break;
      }
      if (!targetApi) return;
      vm.$store.dispatch(`sic_stores_manager/${targetApi}`, {
        store_id: vm.store,
        current_page: parseInt(vm.pagination.current_page) + 1,
        per_page: vm.pagination.per_page,
        search: vm.searchInput.store
      }).then(() => {
        if (vm.pagination.current_page != vm.pagination.total_page) {
          $state.loaded();
        } else {
          $state.complete();
        }
      });
    },
    changeTypeHandler(type) {
      const vm = this;
      vm.searchInput.store = "";
      switch (type) {
        case 'index-sa':
          if (vm.nowSelectType === 'index-sa') return;
          vm.nowSelectType = 'index-sa';
          vm.$store.commit('sic_stores_manager/resetHandler');
          vm.infiniteId += 1;
          break;
        case 'index-member':
          if (vm.nowSelectType === 'index-member') return;
          vm.nowSelectType = 'index-member';
          vm.$store.commit('sic_stores_manager/resetHandler');
          vm.infiniteId += 1;
          break;
        case 'index-reservation':
          if (vm.nowSelectType === 'index-reservation') return;
          vm.nowSelectType = 'index-reservation';
          vm.$store.commit('sic_stores_manager/resetHandler');
          vm.$store.dispatch('sic_stores_manager/getIndexReservationHandler', {
            store_id: vm.store,
            current_page: vm.pagination.current_page + 1,
            per_page: vm.pagination.per_page,
          });
          vm.$store.commit('toggleLoading', false);
          break;
        case 'index-change-member-sa':
          if (vm.nowSelectType === 'index-change-member-sa') return;
          vm.nowSelectType = 'index-change-member-sa';
          vm.$store.commit('sic_stores_manager/resetHandler');
          vm.infiniteId += 1;
          break;
        default:
          break;
      }
    },
    changeStatusHandler(type) {
      const vm = this;
      switch (type) {
        case 'checked':
          if (vm.nowSelectStatus === 'checked') return;
          vm.nowSelectStatus = 'checked';
          vm.$store.commit('sic_stores_manager/resetHandler');
          vm.infiniteId += 1;
          break;
        case 'checking':
          if (vm.nowSelectStatus === 'checking') return;
          vm.nowSelectStatus = 'checking';
          vm.$store.commit('sic_stores_manager/resetHandler');
          vm.infiniteId += 1;
          break;
        case 'success':
          if (vm.nowSelectStatus === 'success') return;
          vm.nowSelectStatus = 'success';
          vm.$store.commit('sic_stores_manager/resetHandler');
          vm.infiniteId += 1;
          break;
        case 'expired':
          if (vm.nowSelectStatus === 'expired') return;
          vm.nowSelectStatus = 'expired';
          vm.$store.commit('sic_stores_manager/resetHandler');
          vm.infiniteId += 1;
          break;
        default:
          break;
      }
    },
    editSaHandler(sa_info) {
      const vm = this;
      vm.$router.push({
        name: SIC_STORES_MANAGER_EDIT_SA,
        params: {
          sa_info,
          store_id: vm.storesSelect.store.id
        }
      });
    },
    // 更換經銷商
    selectDealerHandler(selectedOption) {
      const vm = this;
      if (!selectedOption) return;
      vm.$store.commit('sic_stores_manager/resetHandler');
      vm.storesSelect.store = null;

      vm.$swal.fire({
        title: '載入中，請稍候',
        allowOutsideClick: false,
        willOpen: () => {
          this.$swal.showLoading();
        }
      });

      vm.$store.dispatch('sic_stores_manager/getStoresHandler', {
        store_dealer_id: selectedOption.id
      })
        .then(() => {
          if (vm.personnelStore && vm.personnelStore.length > 0) {
            vm.$store.commit('sic_stores_manager/resetHandler');
            vm.infiniteId += 1;
          }
          vm.$swal.close();
        });
    },
    // 更換店家
    selectStoreHandler(selectedOption) {
      const vm = this;
      if (!selectedOption) return;
      vm.$store.commit('sic_stores_manager/resetHandler');
      if (vm.nowSelectType === 'index-reservation') {
        vm.nowSelectType = 'index-reservation';
        vm.$store.commit('sic_stores_manager/resetHandler');
        vm.$store.dispatch('sic_stores_manager/getIndexReservationHandler', {
          store_id: vm.store,
          current_page: vm.pagination.current_page + 1,
          per_page: vm.pagination.per_page,
        });
      } else {
        vm.infiniteId += 1;
      }
    },
    routerBack() {
      this.$router.back();
    },
    isChecked(index) {
      const vm = this;
      const key = _.findKey(vm.selectTemps, (val) => val.id === vm.storeData[index].id);
      if (key) {
        return true;
      }
      return false;
    },
    // 選擇模板
    selectTempHandler(id) {
      const vm = this;
      const selectTemps_key = _.findKey(vm.selectTemps, (val) => val.id === id);
      if (selectTemps_key) {
        vm.selectTemps.splice(selectTemps_key, 1);
      } else {
        const temps_key = _.findKey(vm.storeData, (val) => val.id === id);
        if (temps_key) {
          vm.selectTemps.push(vm.storeData[temps_key]);
        }
      }
    },
    checkChangeMemberhHandler() {
      const vm = this;
      if (vm.selectTemps.length === 0) {
        vm.$swal.fire({
          icon: 'error',
          title: '請選擇顧客'
        });
        return;
      }
      vm.isChangeMember = true;
    },
    closeCheckChangeMember() {
      const vm = this;
      vm.isChangeMember = false;
    },
    sendChangeMemberhHandler() {
      const vm = this;
      if (vm.selectTemps.length === 0) {
        vm.$swal.fire({
          icon: 'error',
          title: '請選擇顧客'
        });
        return;
      }
      const data = {
        members: _.map(vm.selectTemps, (val) => val.id),
        heirSaId: vm.changePersonnel.id
      }
      vm.$store.dispatch('sic_stores_manager/changeMemberSaHandler', data)
        .then(() => {
          vm.selectTemps = null;
          vm.isChangeMember = false;
          vm.$swal.close();
      });
    },
    updateStoreDataHandler() {
      const vm = this;
      vm.searchInput.store = "";
      vm.$store.commit('sic_stores_manager/resetHandler');
      vm.$store.dispatch('sic_stores_manager/getAllSaHandler', {
        store_id: vm.store,
        current_page: vm.pagination.current_page + 1,
        per_page: 99999
      });
      vm.infiniteId += 1;
    },
    searchHandler() {
      this.$store.commit('sic_stores_manager/resetHandler');
      this.infiniteId += 1;
    }
  },
  computed: {
    ...mapState({
      storeData: (state) => state.sic_stores_manager.storeData,
      storeDealer: (state) => state.sic_stores_manager.storeDealer,
      stores: (state) => state.sic_stores_manager.stores,
      storeInfo: (state) => state.sic_stores_manager.storeInfo,
      pagination: (state) => state.sic_stores_manager.pagination,
      personnel: (state) => state.sic_stores_manager.personnel,
      personnelStore: (state) => state.sic_stores_manager.personnelStoreData
    })
  }
};
</script>

<style lang="scss" scoped>
.multiselect__placeholder {
  margin-bottom: 8px;
}
@font-face {
  font-family: "icon";
  src: url("../../../assets/fonts/icon.eot?hrpp7d");
  src: url("../../../assets/fonts/icon.eot?hrpp7d#iefix") format("embedded-opentype"), url("../../../assets/fonts/icon.ttf?hrpp7d") format("truetype"), url("../../../assets/fonts/icon.woff?hrpp7d") format("woff"), url("../../../assets/fonts/icon.svg?hrpp7d#icon") format("svg");
  font-weight: normal;
  font-style: normal;
  font-display: block;
}

#header_back {
  font-size: 1.7rem;
  padding: 0.5rem;
  position: absolute;
  top: 3%;
  left: 1.6rem;
  -webkit-transform: translate(0, -50%);
  transform: translate(0, -50%);
  cursor: pointer;
  color: #fff !important;
  z-index: 15;
}

i.custom {
  /* use !important to prevent issues with browser extensions that change fonts */
  font-family: "icon" !important;
  speak: never;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  /* Better Font Rendering =========== */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.icon-icon_arrowLeft {
  top: 0;
  left: 5px;
}

.icon-icon_arrowLeft:before {
  content: "\e907";
}

.icon-icon_circlemember:before {
  content: "\e90e";
}

.icon-icon_close:before {
  content: "\e908";
}

.counter_tabs {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  -webkit-box-align: stretch;
  -ms-flex-align: stretch;
  align-items: stretch;
  padding: 0 1rem;
  border-bottom: 0.2rem solid #000;
}

.counter_tab {
  font-size: 1rem;
  font-weight: 600;
  background-color: #d9d9d9;
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
  text-align: center;
  border-radius: 1rem 1rem 0 0;
  padding: 0.6rem 0;
  cursor: pointer;
}

.counter_tab:not(:first-child) {
  margin-left: 2%;
}

.counter_container {
  padding: 0 4rem;
}

.counter_container.active {
  padding-bottom: 9.6rem;
}

.counter_content {
  padding-top: 2rem;
}

.counter_content-client {
  display: none;
}

.counter_content-reservation {
  display: none;
}

.counter_content-assignment {
  display: none;
}

.member_number {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: start;
  -ms-flex-pack: start;
  justify-content: flex-start;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  font-size: 2.6rem;
  font-weight: 600;
}

.member_number_icon {
  font-size: 3rem;
  margin-right: 0.5rem;
}

.member_number_text {
  color: #ef4852;
  margin-right: 0.5rem;
}

.member > a {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: start;
  -ms-flex-pack: start;
  justify-content: flex-start;
  -webkit-box-align: start;
  -ms-flex-align: start;
  align-items: flex-start;
  padding: 2.5rem 0;
  cursor: pointer;
}

.member:not(:first-child) {
  border-top: 1px solid #bdbdbd;
}

.member > label {
  padding: 2.5rem 0;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: start;
  -ms-flex-pack: start;
  justify-content: flex-start;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  cursor: pointer;
}

.member > label .input_wrap {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: start;
  -ms-flex-pack: start;
  justify-content: flex-start;
  -webkit-box-align: start;
  -ms-flex-align: start;
  align-items: flex-start;
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
}

.member_pic {
  width: 12rem;
  height: 12rem;
  border-radius: 50%;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  margin-right: 2rem;
}

.member_info {
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
  word-break: break-all;
}

.member_name {
  font-weight: 600;
  font-size: 1.2rem;
}

.member_text dl {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: start;
  -ms-flex-pack: start;
  justify-content: flex-start;
  -webkit-box-align: start;
  -ms-flex-align: start;
  align-items: flex-start;
}

.member_text dl:not(:first-child) {
  margin-top: 1rem;
}

.member_text dd {
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
}

.ba_client {
  margin-top: 2rem;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: start;
  -ms-flex-pack: start;
  justify-content: flex-start;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  font-size: 2.4rem;
  font-weight: 600;
}

.ba_client .ba_client_icon {
  font-size: 3rem;
}

.ba_client .ba_client_icon i {
  vertical-align: -1px;
}

.member_check_icon {
  width: 4.5rem;
  height: 4.5rem;
  background-color: #fff;
  border-radius: 1rem;
  margin-right: 3rem;
  position: relative;
}

.member_check_icon::after {
  display: none;
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  width: 3.3rem;
  height: 2.4rem;
  background-image: url(../../../assets/images/icon/check-1.png);
  background-size: 3.3rem;
  background-repeat: no-repeat;
}

.member_checker:checked ~ .member_check_icon {
  background-color: #ef4852;
}

.member_checker:checked ~ .member_check_icon::after {
  display: block;
}

.member_assignment_modal {
  border-radius: 0.8rem;
}

.member_assignment_modal .btn_wrap {
  margin-top: 4rem;
}

.member_assignment_modal select {
  cursor: pointer;
}

.modal_header {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  font-size: 1.6rem;
  font-weight: 600;
  background-color: #FFF !important;
  color: #000 !important;
}

.modal_close_btn {
  cursor: pointer;
}

.assignment_client {
  width: 20%;
  position: relative;
}

.assignment_client:not(:nth-child(4n + 1)) {
  margin-left: 6.66%;
}

.assignment_client:nth-child(1n + 5) {
  margin-top: 3rem;
}

.assignment_client_pic {
  width: 100%;
  height: 0;
  padding-bottom: calc(100% - 0.8rem);
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  border-radius: 50%;
  margin-bottom: 1rem;
}

.assignment_client_name {
  font-size: 2.6rem;
  text-align: center;
  word-break: break-all;
  line-height: 1.2;
}

.assignment_client_delete {
  width: 2.2rem;
  height: 2.2rem;
  background-color: #000;
  font-size: 1.1rem;
  color: #fff;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  border-radius: 50%;
  position: absolute;
  right: 0;
  top: 0;
  -webkit-transform: translate(50%, 0);
  transform: translate(50%, 0);
  cursor: pointer;
}

.assignment_clients {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: start;
  -ms-flex-pack: start;
  justify-content: flex-start;
  -webkit-box-align: start;
  -ms-flex-align: start;
  align-items: flex-start;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  margin-top: 4rem;
  padding-right: 2rem;
}

.assignment_ba_text {
  font-size: 2.8rem;
  text-align: center;
  margin-top: 4rem;
  margin-bottom: 2rem;
}

.tab_style.active {
  color: #fff !important;
}

.tab_style.active {
  background-color: #000 !important;
}

.border-black{
  border: 0.2rem solid #000;
}

.outline-invitation {
  display: block;
  border-radius: 1rem;
  padding: 1rem;
  cursor: pointer;
}
.custom-shadow {
  -webkit-box-shadow: 0.2rem 0.2rem 0 #00000033;
  box-shadow: 0.2rem 0.2rem 0 #00000033;
}

.invitation-icon {
  width: 1.8rem;
  height: 1.8rem;
  background-color: #fff;
  border-radius: 0.4rem;
  margin-right: 1.2rem;
  position: relative;
}

.invitation_checker:checked ~ .input_wrap .invitation-icon {
  background-color: #ef4852;
}

.invitation_checker:checked ~ .input_wrap .invitation-icon::after {
  display: block;
}

.invitation-icon::after {
  content: '';
  display: none;
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  width: 1.5rem;
  height: 1rem;
  background-image: url(../../../assets/images/icon/check-1.png);
  background-size: 1.5rem;
  background-repeat: no-repeat;
}

.invitation_info {
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
}

input[type="checkbox"], input[type="radio"] {
  position: absolute;
  width: 1px;
  height: 1px;
  display: none;
  opacity: 0;
}

.custom-member {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: start;
  -ms-flex-pack: start;
  justify-content: flex-start;
  -webkit-box-align: start;
  -ms-flex-align: start;
  align-items: flex-start;
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
}
.modal_body {
  flex-wrap: wrap;
}
select {
  background-image: url(../../../assets/images/icon/arrow-dropdown-1.png);
  background-repeat: no-repeat;
  background-size: 1rem;
  background-position: center right 1.2rem;
}
.custom-select:focus {
  outline: 0;
  box-shadow: 0 0 0 0;
}
</style>
